import { Typography } from 'antd'
import { TitleProps as TitleAntdProps } from 'antd/es/typography/Title'
import classNames from 'classnames'
import { ReactNode } from 'react'

import s from '../Text.module.scss'

const { Title: TitleAntd } = Typography

interface TitleProps extends TitleAntdProps {
  children: ReactNode
}

export const Title = ({ children, level = 1, ...props }: TitleProps) => {
  const classes = classNames(s.title, {
    [s.titleLevel1]: level === 1,
    [s.titleLevel2]: level === 2,
    [s.titleLevel3]: level === 3,
    [s.titleLevel4]: level === 4,
    [s.titleLevel5]: level === 5,
  })

  return (
    <TitleAntd {...props} level={level} className={classes}>
      {children}
    </TitleAntd>
  )
}
